import { normalizeUserId, parseSessionId } from '@/lib/user-session-rules';

function isVisitorUserId(userId: string): boolean {
  return /^[a-f0-9]{32}$/.test(userId);
}

export function getHistorySessionUserId(sessionId: unknown, currentUserId: unknown): string | null {
  const parsedSession = parseSessionId(sessionId);
  if (parsedSession && isVisitorUserId(parsedSession.userId)) {
    return parsedSession.userId;
  }

  const normalizedCurrentUserId = normalizeUserId(currentUserId);
  if (parsedSession && parsedSession.userId !== normalizedCurrentUserId) {
    return null;
  }

  return normalizedCurrentUserId;
}
